import { combineReducers } from '@reduxjs/toolkit'

import { REDUCER_INDEX } from 'users'

import * as currentUser from './currentUser'
import * as favorites from './favorites'

import type { FAVORITES_CATEGORIES } from 'users'

export * as currentUser from './currentUser'

export const actions = {
  ...currentUser.actions,
  ...favorites.actions,
}

export const epics = [...favorites.epics, ...currentUser.epics]

export const reducer = combineReducers({
  currentUser: currentUser.reducer,
  favorites: favorites.reducer,
})

export const selectors = {
  currentUser: Object.assign(
    ({ [REDUCER_INDEX]: state }: { [REDUCER_INDEX]: ReturnType<typeof reducer> }) => state.currentUser,
    currentUser.selectors,
  ),
  favorites: (
    { [REDUCER_INDEX]: state }: { [REDUCER_INDEX]: ReturnType<typeof reducer> },
    category: FAVORITES_CATEGORIES | undefined = undefined,
  ) => (category ? state.favorites[category] : state.favorites),
  favoritesCategory:
    (category: FAVORITES_CATEGORIES) =>
    ({ [REDUCER_INDEX]: state }: { [REDUCER_INDEX]: ReturnType<typeof reducer> }) =>
      state.favorites[category],
}

export const registerReducer = (state: Record<string, unknown>) => ({
  ...state,
  [REDUCER_INDEX]: reducer,
})
